module.exports = __webpack_public_path__ + "img/after.fa0a9fba.png";